const TagLabel = ({ tag, close}) => {
    return (
        <div className="bg-[#225424] text-white py-2 px-3 rounded-lg flex items-center gap-2 text-lg">{tag} <div className="pt-2"><i className="fi fi-sr-circle-xmark text-xl cursor-pointer" onClick={() => {close(tag)}}></i></div></div>
    )
}

export default TagLabel;